import React from 'react'

import './FaqTagCloud.scss'

const FaqTagCloud = props => {
  const { tagCloud = [], handleTag } = props
  return (
    <div className="FaqTagCloud">
      {(Array.isArray(tagCloud) ? tagCloud : []).map(item => (
        <div
          className="FaqTagCloud__tagItem"
          key={`${item.description}+${item.id}`}
          onClick={() => handleTag(item.id)}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              handleTag(item.id)
            }
          }}
          role="button"
          tabIndex="0"
        >
          <h5>{item.tag}</h5>
        </div>
      ))}
    </div>
  )
}

export default FaqTagCloud
